var exports = {
  "jY": "EnforcementIconOcticonAttention__ZhOJoQ",
  "W3": "EnforcementIconOcticonSuccess__wIgZ98",
  "FH": "EnforcementIconOcticonSevere__JnyiLG",
  "_V": "EnforcementIconOcticonMuted__CaHT9T",
  "$6": "EnforcementIconContainer__C4VsWv",
  "XK": "EnforcementIconText__tX5EZX",
};

module.exports = exports;
